/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import {REPORTS_MILEAGE_ROUTE} from "../../../../../constants/routes";
/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoMileage from "../../../../reportsNoMileage"

/* Styles */
import styles from "./styles.js"


const BookingGrid = (props) => {
  const {gridOptions, setGridOptions, mileageResponse, onRowClick} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.mileageGrid}>
      <UCGrid
        gridName="mileageGrid"
        data={ mileageResponse?.results }
        columns={ mileageResponse?.columns }
        actions={ mileageResponse?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        });
        page > 1 ? navigate(`/app/reports/mileage?page=${page}`) : navigate(`/app/reports/mileage`)
        }}
        setSelectedRow={setSelectedRow}
        spinner="mileageGridSpinner"
        customColumns={{
          parentName: (row) => (
            <Link to={`${"../../" + REPORTS_MILEAGE_ROUTE}/${row.parentID}`} className={classes.link}>
              {row.parentName}
            </Link>
          ),
          passengerName: (row) => {
            const name = `${row.passengerName || ""}`;
            return (
              <div className={classes.details}>
                <p>{ name }</p>
              </div>
            )
          }
        }}
        columnCustomWidth={{
          flightDate: "190px !important",
          bookingDate: "190px !important"
        }}
        noDataComponent={ <ReportsNoMileage/> }
        showHeader={true}
        persistTableHead={false}      
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default BookingGrid;
